export default class OtherChargesSerializer {
  static serialize(data) {
    const payload =  {
      ...data,
      amount: data.amount,
      charge_id: data.chargeId,
      stop_id: data.stopId,
      descr: data.description
    };

    const customProperties = [
      "chargeId",
      "stopId",
      "description"
    ];

    customProperties.forEach(prop => delete payload[prop]);
    return payload;
  }

  static deSerialize(data) {
    return {
      ...data,
      amount: data.amount,
      chargeId: data.charge_id,
      description: data.descr,
      stopId: data.stop_id
    };
  }
}